"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var constant_1 = require("../../constant");
var constants_1 = require("./constants");
var context_1 = require("./context");
var getFooterStyle = function (theme, size) {
    return react_1.css(__assign({ borderTop: theme.border }, (theme.name === constant_1.DESIGN_SYSTEM ? ({
        padding: constants_1.SIZE_TO_PADDING[size],
    }) : ({
        padding: '20px 30px',
    }))));
};
var CardFooter = function (props) {
    var theme = react_1.useTheme();
    var size = react_2.useContext(context_1.CardContext).size;
    var footerStyle = react_2.useMemo(function () { return getFooterStyle(theme, size); }, [theme, size]);
    return react_1.jsx("div", __assign({}, props, { css: footerStyle }));
};
exports.default = CardFooter;
